/**
 * Type d'extension de fichiers
 */

export const PDF_TYPE = 'pdf';
export const DOCX_TYPE = 'docx';
export const SVG_TYPE = 'svg';
export const JPEG_TYPE = 'jpeg';
export const JPG_TYPE = 'jpg';
export const PNG_TYPE = 'png';
export const JPEG_TYPE_M = 'JPEG';
export const JPG_TYPE_M = 'JPG';
export const PNG_TYPE_M = 'PNG';
export const XLS_TYPE = 'xls';
export const XLSX_TYPE = 'xlsx';

export const IMAGE_EXTENSIONS = [JPG_TYPE, JPG_TYPE_M, JPEG_TYPE, JPEG_TYPE_M, PNG_TYPE, PNG_TYPE_M];
export const DOCUMENT_EXTENSIONS = [PDF_TYPE, DOCX_TYPE, SVG_TYPE, XLS_TYPE, XLSX_TYPE];
export const ALL_EXTENSIONS = [...IMAGE_EXTENSIONS, ...DOCUMENT_EXTENSIONS];
